// src/components/ui/LowBalanceWarning.tsx
import React from 'react';

interface Props {
  balance: number;
  onTopUp?: () => void;
}

export function LowBalanceWarning({ balance, onTopUp }: Props) {
  if (balance >= 20) return null;

  const isOut = balance === 0;

  return (
    <div className={`mx-4 mb-2 rounded-lg border px-3 py-2 text-xs flex items-center justify-between gap-2 ${
      isOut ? 'bg-red-50 border-red-200 text-red-700' : 'bg-amber-50 border-amber-200 text-amber-700'
    }`}>
      <span>
        {isOut
          ? '⚠️ You\'re out of tokens. Top up to continue chatting.'
          : `⚡ Only ${balance} tokens left. Each message uses 50–200 tokens.`}
      </span>
      {onTopUp && (
        <button
          onClick={onTopUp}
          className={`flex-shrink-0 text-xs font-medium rounded px-2 py-0.5 ${
            isOut ? 'bg-red-600 text-white hover:bg-red-700' : 'bg-amber-600 text-white hover:bg-amber-700'
          } transition-colors`}
        >
          Top up
        </button>
      )}
    </div>
  );
}
